const SEND_TEXT_EMAIL_NOTIFICATION_FORM = {
    submit: {
        label: 'send_test_email_modal.submit_btn'
    },
    fields: [
        {
            name: 'email',
            label: 'send_test_email_modal.email_field',
            type: 'text',
            validators: ['required', 'isEmail'],
            errors: ['errors.required_email', 'errors.invalid_email'],
            defaultValue: ''
        }
    ]
}

export default SEND_TEXT_EMAIL_NOTIFICATION_FORM;
